import { createContext, Dispatch, SetStateAction, useContext } from 'react';

export interface IConversationContextSet {
  conversationId: string | null;
  setConversationId: Dispatch<SetStateAction<string | null>>;
}

export const ConversationIdKey = 'ConversationId';

// Create the context with an initial value
export const ConversationContext = createContext<IConversationContextSet | null>(null);

export const useConversationContext = () => {
  const context = useContext(ConversationContext);
  if (!context) {
    throw new Error('useConversationContext must be used within an ConversationContextProvider');
  }
  return context;
};


